import { useQuery } from "@apollo/client";
import { Container, Paper, Typography } from "@mui/material";
import { DataGrid, type GridColDef, type GridEventListener } from "@mui/x-data-grid";
import { csCZ } from "@mui/x-data-grid/locales";
import { DateTime } from "luxon";
import ErrorLayout from "../../components/layout/ErrorLayout";
import LoadingCircle from "../../components/LoadingCircle";
import { translateEntityKind } from "../../utils/FileTableUtils";
import { GET_MANUAL_TEXTS } from "./gql";
import { useNavigate } from "react-router-dom";

const Manuals = () => {
  const navigate = useNavigate();

  const { loading, error, data } = useQuery(GET_MANUAL_TEXTS, {
    variables: {
      gridName: "MANUAL",
    },
  });

  const handleRowClick: GridEventListener<"rowClick"> = (params) => {
    navigate(`/manualy/${params.row.id}`);
  };

  const columns: GridColDef[] = [
    {
      headerName: "Vytvořeno",
      field: "createdAt",
      width: 200,
      valueFormatter: (value) =>
        DateTime.fromISO(value).toFormat("d.M.yyyy HH:mm"),
    },
    {
      headerName: "Typ",
      width: 250,
      field: "relatedToEntity",
      valueGetter: (_, row) =>
        translateEntityKind(data.enumerations, row.relatedToEntity),
    },
    { headerName: "Popis", field: "poznamka", flex: 1 },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  if (loading) return <LoadingCircle />;
  if (error) return <ErrorLayout errorMsg={error.message || ""} />;

  return (
    <Container>
      <Typography variant="h2" mb={2}>
        Manuály
      </Typography>

      <Paper sx={{ width: "100%" }}>
        <DataGrid
          rows={data.texts}
          columns={columns}
          initialState={{
            pagination: { paginationModel },
            sorting: { sortModel: [{ field: "createdAt", sort: "desc" }] },
          }}
          pageSizeOptions={[10, 15]}
          sx={{
            border: 0,
            "& .MuiDataGrid-row:hover": {
              cursor: "pointer",
            },
          }}
          disableRowSelectionOnClick
          localeText={csCZ.components.MuiDataGrid.defaultProps.localeText}
          onRowClick={handleRowClick}
        />
      </Paper>
    </Container>
  );
};

export default Manuals;
